import type { JSX } from "preact";
import type { RenderElementProps } from "slate-react";
import { useSelected } from "slate-react";
import type { LinkElement } from "./types";

interface Parameters extends RenderElementProps {
    element: LinkElement;
}

export function Link({
    element,
    attributes,
    children,
}: Parameters): JSX.Element {
    const selected = useSelected();

    return (
        <a
            {...attributes}
            href={element.url}
            className={selected ? "selected" : undefined}
        >
            {children}
        </a>
    );
}
